import authFetch from '../../helpers/authFetch';

/** Page size for the deck loader; the server caps pages, so the loader walks every page. */
export const DECK_PAGE_LIMIT = 100;

/**
 * Safety cap on a bad totalPages from the server, not a deck-size rule. Constructed
 * formats have no maximum deck size, so a legitimate deck can exceed any size-based
 * page count; this only stops a runaway page walk.
 */
export const MAX_DECK_PAGES = 50;

const DECK_QUERY = 'zone=main&include=card,tags&sort=date_added&order=asc';

const deckPageUrl = (collectionId, page) =>
  `/collections/${collectionId}?${DECK_QUERY}&limit=${DECK_PAGE_LIMIT}&page=${page}`;

/**
 * Loads every main-zone entry of a deck before play starts. Sideboard entries
 * are never requested. Any failed page rejects the whole load, so a partial
 * deck is never returned.
 */
export const loadWholeDeck = async (collectionId) => {
  const rows = [];
  let deckType = null;
  let totalPages = 1;
  let page = 1;
  do {
    const response = await authFetch(deckPageUrl(collectionId, page));
    if (!response.ok) {
      throw new Error(`Deck page ${page} failed with status ${response.status}`);
    }
    const body = await response.json();
    if (!Array.isArray(body.entries) || !Number.isInteger(body.pagination?.totalPages)) {
      throw new Error(`Deck page ${page} has an unexpected shape`);
    }
    if (page === 1) deckType = body.deck_type ?? null;
    rows.push(...body.entries);
    totalPages = body.pagination.totalPages;
    if (totalPages > MAX_DECK_PAGES) {
      throw new Error(`Deck has ${totalPages} pages, more than the ${MAX_DECK_PAGES} a playtest may load`);
    }
    page += 1;
  } while (page <= totalPages);
  return { rows, deckType };
};
